import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDiamondShine: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="diamond-shine, pop, polish"><path d="M16.25 7.75H7.75L3.75 12.75L12 21.25L20.25 12.75L16.25 7.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M4.5 12.75H19.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 2.75V4.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.5 4.5L19.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.5 4.5L4.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDiamondShine;
